import PillarCard from "../../components/ybf/PillarCard";
import KPIScorecard from "../../components/ybf/KPIScorecard";
import BeneficiariesHeatmap from "../../components/ybf/BeneficiariesHeatmap";
import { useFY } from "../../context/FYContext";
import { PILLARS } from "../../data/ybf/pillars";
import { Users, MapPin, Building2, IndianRupee, TreePine, Cloud, Handshake, Sparkles } from "lucide-react";

export default function Overview() {
  const { fy, snapshot } = useFY();
  const k = snapshot.headline;

  return (
    <div data-testid="ybf-overview" className="space-y-5 pb-8">
      {/* Hero */}
      <div className="bg-gradient-to-r from-gray-100 via-gray-200 to-gray-100 text-gray-900 rounded-2xl p-6 relative overflow-hidden border-t-4 border-[#E2231A]">
        <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-[#E2231A]/10 blur-3xl -translate-y-1/2 translate-x-1/2" />
        <div className="absolute bottom-0 left-1/3 w-48 h-48 rounded-full bg-gray-400/10 blur-3xl translate-y-1/2" />
        <div className="relative">
          <div className="flex items-center gap-2 mb-2">
            <Sparkles size={14} className="text-[#E2231A]" />
            <span className="text-[10px] uppercase tracking-widest text-gray-500 font-semibold">Lenovo India · Smarter Technology for All</span>
          </div>
          <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-gray-900">Bridging the digital divide</h1>
          <p className="text-sm text-gray-600 mt-2 max-w-2xl">
            STEM Education, Digital Literacy, Employability &amp; Skilling, and Sustainability — Lenovo India's CSR focus areas for an inclusive, future-ready India.
          </p>
          <div className="mt-3 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-white/70 border border-gray-300 text-gray-700 text-[11px] font-semibold">
            <span className="text-gray-500">Viewing</span>
            <span data-testid="overview-fy-badge">{fy}</span>
          </div>
        </div>
      </div>

      {/* Headline KPIs */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <KPIScorecard icon={Users}       label="Students & youth reached" value={k.beneficiaries.value} prev={k.beneficiaries.prev} accent="#1A1A1A" />
        <KPIScorecard icon={MapPin}      label="States reached"          value={k.states.value}        prev={k.states.prev}        accent="#6B7280" />
        <KPIScorecard icon={Building2}   label="Districts reached"       value={k.districts.value}     prev={k.districts.prev}     accent="#3A3A3A" />
        <KPIScorecard icon={Handshake}   label="Implementation partners" value={k.partners.value}      prev={k.partners.prev}      accent="#E2231A" />
        <KPIScorecard icon={IndianRupee} label="Program spend"           value={k.programSpendCr.value} prev={k.programSpendCr.prev} unit="₹ Cr" accent="#B45309" />
        <KPIScorecard icon={IndianRupee} label="Economic potential"      value={k.econPotentialCr.value} prev={k.econPotentialCr.prev} unit="₹ Cr" accent="#6B7280" />
        <KPIScorecard icon={TreePine}    label="Trees planted (FY)"      value={k.treesPlanted.value}  prev={k.treesPlanted.prev}  accent="#22C55E" />
        <KPIScorecard icon={Cloud}       label="CO₂ avoided"             value={k.co2Tonnes.value}     prev={k.co2Tonnes.prev}     unit="t" accent="#10B981" />
      </div>

      {/* 3Es Pillar Cards */}
      <div>
        <h2 className="text-lg font-bold text-slate-900 mb-3">Our Focus Areas — Click to drill in</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {PILLARS.map((p) => <PillarCard key={p.id} pillarId={p.id} />)}
        </div>
      </div>

      {/* Trend charts */}
      <div className="grid grid-cols-1 gap-4">
        <BeneficiariesHeatmap />
      </div>
    </div>
  );
}
